import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-more-tools',
  templateUrl: './more-tools.component.html',
  styleUrls: ['./more-tools.component.css']
})
export class MoreToolsComponent implements OnInit {

  // Define the array to hold the tools data
  tools = [
    {
      image: '/assets/tools/media.svg',
      title: 'Media Library',
      description: 'Store, organize, and easily retrieve all your images, videos, and files in one central location for seamless content creation.'
    },
    {
      image: '/assets/tools/insights.svg',
      title: 'Insights',
      description: 'Gain powerful analytics to track content performance, understand audience behavior, and refine strategies for improved engagement.'
    },
    {
      image: '/assets/tools/bulkimport.svg',
      title: 'Bulk Imports',
      description: 'Upload and schedule hundreds of posts in seconds. Simplify your workflow with CSV support for images, carousels, and stories.'
    },
    {
      image: '/assets/tools/cross.svg',
      title: 'Cross-posting',
      description: 'Share posts across multiple platforms, including Instagram, Twitter, LinkedIn, and Pinterest, to maintain consistency and save time.'
    },
    {
      image: '/assets/tools/addto.svg',
      title: 'Add to Queue',
      description: 'Easily schedule posts by adding them to a queue. Ensure your content is published at the right time to maximize reach and engagement.'
    },
    {  image: '/assets/tools/recycle.svg',
      title: 'Recycle Post',
      description: 'Keep your feed fresh by recycling trending posts. Add captions and hashtags to breathe new life into your evergreen content.'
    },
    {
      image: '/assets/tools/auto.svg',
      title: 'Auto Retweet',
      description: 'Set conditions for automatic retweets based on engagement metrics like likes or hours, boosting your Twitter presence with zero hassle.'
    },
    {
      image: '/assets/tools/calender.svg',
      title: 'Calender View',
      description: 'Plan all your posts in a dynamic calendar view. Visualize daily, weekly, or monthly schedules for streamlined content management.'
    },
    {
      image: '/assets/tools/instagram.svg',
      title: 'Instagram Stories',
      description: 'Automate Instagram stories effortlessly. Queue up daily posts to keep your audience engaged without manual effort.'
    },
    {
      image: '/assets/tools/carousel.svg',
      title: 'Social Media Carousel',
      description: 'Craft eye-catching carousels with up to 10 slides of images, videos, or both. Schedule them for optimal impact and reach.'
    },
    {
      image: '/assets/tools/followupcomments.svg',
      title: 'Follow-Up Commments',
      description: 'Engage your audience effectively by scheduling follow-up comments based on likes, shares, or activity duration for enhanced visibility.'
    },
    {
      image: '/assets/tools/auto.svg',
      title: 'Auto-thread for Twitter & Threads',
      description: 'Create seamless Twitter threads by auto-scheduling replies. Just press enter to add new tweets and maintain a strong conversation flow.'
    },
    
  ];

  constructor() { }

  ngOnInit(): void {
  }
}
